export const WEB_ROUTES = {
	EVENT_DETAIL: (id: string) => `/events/${id}`,
	MEETING_DETAIL: (id: string) => `/meetings/${id}`,
	POST_DETAIL: (id: string) => `/posts/${id}`,
	MESSAGES: () => `/messages`,
	EXTERNAL_INVITATION: (token: string) => `/external-invitation?token=${encodeURIComponent(token)}`,
	UNSUBSCRIBE: "/unsubscribe",
	GROUPS: "/groups",
	ADMIN_GROUPS: "/admin/groups",
} as const;
